import {
    Component,
    ElementRef,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    Renderer2,
    TemplateRef,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';

@Component({
    selector: '[hoverTooltip], hover-tooltip',
    templateUrl: './hover-tooltip.component.html',
})
export class HoverTooltipComponent implements OnInit, OnDestroy {
    @Input() hoverTooltipContent: TemplateRef<any>;
    @Input() hoverTooltipData: any;
    @Input() appendToBody = false;

    @ViewChild('tooltip', { static: true }) tooltip: ElementRef;

    container: any;
    top: number;
    navbarHeight: number;
    tooltipheight: number;
    tooltipwidth: number;
    elHeight: number;

    constructor(
        public elRef: ElementRef,
        private readonly _renderer: Renderer2,
        private readonly viewContainerRef: ViewContainerRef,
    ) {}

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnInit() {
        this.navbarHeight = $('.navbar.fixed-top').outerHeight();
    }

    // @HostListener('mouseover', ['$event'])
    // triggerIn(event) {
    //     if (event) {
    //         this.top = this.elRef.nativeElement.getBoundingClientRect().top;
    //         this.elHeight = this.elRef.nativeElement.getBoundingClientRect().height;

    //         this._renderer.setStyle(this.tooltip.nativeElement, 'display', 'block');

    //         if (this.appendToBody) {
    //             $('body').append(this.tooltip.nativeElement);
    //             this._renderer.setStyle(this.tooltip.nativeElement, 'position', 'fixed');
    //         }

    //         this.tooltipheight = this.tooltip.nativeElement.clientHeight;
    //         this.tooltipwidth = this.tooltip.nativeElement.clientWidth;

    //     }
    // }

    @HostListener('mousemove', ['$event'])
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    triggerMove(event) {
        if (event) {
            // ----------------------------
            this.top = this.elRef.nativeElement.getBoundingClientRect().top;
            this.elHeight =
                this.elRef.nativeElement.getBoundingClientRect().height;

            this._renderer.setStyle(
                this.tooltip.nativeElement,
                'display',
                'block',
            );

            if (this.appendToBody) {
                $('body').append(this.tooltip.nativeElement);
                this._renderer.setStyle(
                    this.tooltip.nativeElement,
                    'position',
                    'fixed',
                );
            }

            this.tooltipheight = this.tooltip.nativeElement.clientHeight;
            this.tooltipwidth = this.tooltip.nativeElement.clientWidth;
            // ----------------------------

            const off = this.top - this.tooltipheight + $(window).scrollTop();
            const topborder = this.navbarHeight + $(window).scrollTop();

            const halfwidth = this.tooltipwidth / 2;

            let left = event.offsetX - halfwidth;

            if (this.appendToBody) {
                left = event.clientX - halfwidth;
            }

            // if tooltip will collide with navigation bar
            if (off < topborder) {
                $(this.tooltip.nativeElement)
                    .find('.custom-tooltip')
                    .addClass('custom-tooltip-bottom')
                    .removeClass('custom-tooltip');

                let top = '30px';
                if (this.appendToBody) {
                    top = `${this.top + this.elHeight + 5}px`;
                }
                this._renderer.setStyle(this.tooltip.nativeElement, 'top', top);
            } else {
                $(this.tooltip.nativeElement)
                    .find('.custom-tooltip-bottom')
                    .addClass('custom-tooltip')
                    .removeClass('custom-tooltip-bottom');

                let top = `${-(this.tooltipheight + 5)}px`;
                if (this.appendToBody) {
                    top = `${this.top - (this.tooltipheight + 5)}px`;
                }
                this._renderer.setStyle(this.tooltip.nativeElement, 'top', top);
            }
            this._renderer.setStyle(
                this.tooltip.nativeElement,
                'left',
                `${left}px`,
            );
        }
    }

    @HostListener('mouseout', ['$event'])
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    triggerOut(event) {
        if (event) {
            this._removeTooltip();
        }
    }

    @HostListener('click', ['$event'])
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    triggerClick(event) {
        if (event) {
            setTimeout(() => {
                if (
                    !this.elRef.nativeElement ||
                    this.elRef.nativeElement.isConnected === false
                ) {
                    this._removeTooltip();
                }
            });
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnDestroy() {
        console.log('DESTROY TOOLTIP');
        this._removeTooltip();
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    _removeTooltip() {
        this._renderer.setStyle(this.tooltip.nativeElement, 'display', 'none');
        if (this.appendToBody) {
            $(this.elRef.nativeElement).append(this.tooltip.nativeElement);
        }
    }
}
